import React, { Suspense, useEffect, Component } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import SharedNavbar from './components/SharedNavbar';
import {
  AboutRoute,
  ContactRoute,
  DeleteAccountRoute,
  PrivacyRoute,
  ServicesRoute,
  TermsRoute,
  preloadNonCriticalRoutes,
} from './routes';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="route-loader" role="alert">
          <span style={{ fontSize: 32 }}>⚠️</span>
          <span>Something went wrong. <a href="/" style={{ color: '#6366f1' }}>Go home</a></span>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function RouteFallback() {
  return (
    <div className="route-loader" role="status" aria-live="polite">
      <div className="route-loader__spinner" aria-hidden="true" />
      <span>Loading page…</span>
    </div>
  );
}

function AppRouter() {
  useEffect(() => {
    const preload = () => preloadNonCriticalRoutes();
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preload, { timeout: 1000 });
    } else {
      setTimeout(preload, 500);
    }
  }, []);

  return (
    <>
      <ScrollToTop />
      <SharedNavbar />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/about" element={<AboutRoute />} />
          <Route path="/services" element={<ServicesRoute />} />
          <Route path="/contact" element={<ContactRoute />} />
          <Route path="/terms" element={<TermsRoute />} />
          <Route path="/privacy" element={<PrivacyRoute />} />
          <Route path="/delete-account" element={<DeleteAccountRoute />} />
        </Routes>
      </Suspense>
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ErrorBoundary>
      <AppRouter />
    </ErrorBoundary>
  </BrowserRouter>
);


// Dismiss the HTML loader once React has painted the first frame
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const loader = document.getElementById('app-loader');
    if (loader) {
      loader.classList.add('hide');
      setTimeout(() => loader.remove(), 200);
    }
  });
});

reportWebVitals();
